const UNLOCK_AVATARS_FEATURE = [
  {
    src: new URL(
      '~/public/assets/images/Landing/unlockAvatarsFeature.png?as=avif',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/avif'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/unlockAvatarsFeature.png?as=webp',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/webp'
  },
  {
    src: new URL(
      '~/public/assets/images/Landing/unlockAvatarsFeature.png',
      import.meta.url
    ).href,
    alt: 'Landing',
    as: 'image/png'
  }
]

export default UNLOCK_AVATARS_FEATURE
